import React from 'react';
import profileService from '../services/profileService';
import { useFetchData } from '../hooks/fetchDataHooks';
import Loader from './common/loader';
import { Box, Divider, Typography } from '@material-ui/core';

const Hashtags = ({ handleSubmit }) => {
  const { data, isLoading } = useFetchData(profileService.getHashtags, null);
  return (
    <Box>
      <Typography variant="h6">Trending</Typography>
      {isLoading && <Loader key={1} />}
      {data &&
        data.length > 0 &&
        data.map((doc) => (
          <Box key={doc}>
            <Box p={2}>
              <Typography
                variant="body1"
                onClick={() => handleSubmit(doc.substr(1))}
                className="linkColor"
              >
                {doc}
              </Typography>
            </Box>
            <Divider />
          </Box>
        ))}
    </Box>
  );
};

export default Hashtags;
